import React, {useEffect} from 'react';
import styles from './CheckBox.module.scss';
import cn from 'classnames';

function CheckBox({
    name,
    label,
    value,
    onChange,
    onChangeField,
    enabled,
    className,
    labelClassName,
    readOnly,
    id,
    innerId,
}) {
    function handleChange() {
        const nextValue = !value;
        if (readOnly) return;

        if (onChange) {
            onChange(nextValue);
        }
        if (onChangeField) {
            onChangeField({
                target: {
                    name,
                    value: nextValue,
                },
            });
        }
    }

    useEffect(() => {
        if (value && !enabled) {
            handleChange();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled]);

    return (
        <div
            className={cn(
                styles.checkBox,
                {
                    [styles.disabled]: !enabled || readOnly,
                },
                className,
            )}
            onClick={handleChange}
            id={id}
        >
            <div
                className={cn(styles.selectionBox, {
                    [styles.selectionBoxNotSelected]: !value,
                    [styles.selectionBoxSelected]: value,
                })}
                id={innerId}
            />
            <div
                className={cn(styles.label, {
                    [styles.labelNotSelected]: !value,
                    [styles.labelSelected]: value,
                    [labelClassName]: labelClassName,
                })}
            >
                {label}
            </div>
        </div>
    );
}

CheckBox.defaultProps = {
    enabled: true,
};

export default CheckBox;
